import './Spinner.css';

const Spinner = ({ className = null }) => {
	return <div className={`spinner-border ${className ? className : ''}`} role="status" />;
};

export default Spinner;
